export const SET_NODES = "SET_NODES";
export const SET_FROM_DATA = "SET_FROM_DATA";
export const NAV_REQUEST_STARTED = "NAV_REQUEST_STARTED";
export const NAV_REQUEST_FINISHED = "NAV_REQUEST_FINISHED";

export const setNodes = (nodes) => dispatch => {
  dispatch({
    type: SET_NODES,
    nodes
  });
};

export const setFromData = (from) => dispatch => {
  dispatch({
    type: SET_FROM_DATA,
    from
  });
};

export const startNavRequest = () => ({
  type: NAV_REQUEST_STARTED
});

export const finishNavRequest = () => ({
  type: NAV_REQUEST_FINISHED
});


// WEBPACK FOOTER //
// ./src/actions/navbar.js